module.exports = __webpack_public_path__ + "static/img/property_1_ovo.6e9bd05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_ovo.png
// module id = fZWn
// module chunks = 1